import { useContext } from "react";
import { SharePostContext } from "./SharePostContext";

export const useSharePost = (): any => {
  if (!SharePostContext)
    throw new Error("useSharePost must be under CreatePostProvider");
  return useContext(SharePostContext);
};
